import { useTranslation } from "@coworker/locales";
import TitledBoxedText from "@coworker/apprestructured/src/task-management/components/TitledBoxedText/TitledBoxedText";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import {
  FieldFormat,
  useFormatFieldValue,
} from "@coworker/apprestructured/src/task-management/hooks/useFormatFieldValue";

export type TitledBoxedTextViewerFragmentConfigProps = {
  // Translation key for the title
  title: string;
  field: string;
  // Optional: format the raw field value using a named formatter
  format?: FieldFormat;
};

type TitledBoxedTextViewerFragmentProps = {
  configProps: TitledBoxedTextViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function TitledBoxedTextViewerFragment({
  configProps,
  commonProps,
}: TitledBoxedTextViewerFragmentProps) {
  const { field, title, format } = configProps;
  const { task } = commonProps;
  const rawText = getTypedValue<string>(getByPath(task, field));

  const formatFieldValue = useFormatFieldValue();
  const { t } = useTranslation();

  if (isLoading(rawText) || rawText.length === 0) {
    return null;
  }

  const text = formatFieldValue(rawText, format);

  return <TitledBoxedText title={t(title)} text={text} />;
}

export default TitledBoxedTextViewerFragment;
